import React from 'react';
import { SftpSchedule } from '@common/types/sftpSchedule';
import { formatHour } from './formatHour';

const DAY_LABELS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

function formatRecurrenceSummary(schedule: SftpSchedule): string {
  const time = formatHour(schedule.runHourLocal);
  const tz = schedule.timezone;

  switch (schedule.recurrence.pattern) {
    case 'daily':
      return `Every day at ${time} (${tz})`;
    case 'weekly': {
      const days = (schedule.recurrence.daysOfWeek ?? [])
        .sort((a, b) => a - b)
        .map(d => DAY_LABELS[d])
        .join(', ');
      return `Every ${days} at ${time} (${tz})`;
    }
    case 'monthly':
      return `Day ${schedule.recurrence.dayOfMonth} of every month at ${time} (${tz})`;
    default:
      return 'No schedule configured';
  }
}

type ScheduleSummaryProps = {
  schedule: SftpSchedule | null | undefined;
};

export const ScheduleSummary = ({ schedule }: ScheduleSummaryProps) => {
  if (!schedule || !schedule.enabled) {
    return (
      <div
        className="batch-schedule-summary batch-schedule-summary--inactive"
        role="status"
        aria-live="polite"
      >
        <span className="batch-schedule-summary__title">SFTP delivery schedule</span>
        <p className="batch-schedule-summary__text">Not configured. Use Edit Defaults to set an automated schedule.</p>
      </div>
    );
  }

  return (
    <div className="batch-schedule-summary batch-schedule-summary--active" role="status" aria-live="polite">
      <span className="batch-schedule-summary__title">SFTP delivery schedule</span>
      <p className="batch-schedule-summary__text">{formatRecurrenceSummary(schedule)}</p>
    </div>
  );
};
